import { AppConfig } from './AppConfig';

const theme = AppConfig.defaultTheme;

const AppStyles = {
    'html': {
        fontSize: '14px',

        [theme.breakpoints.up('md')]: {
            fontSize: '14px',
        }
    },
    'html>body': {
        backgroundColor: theme.palette.background.default,

        [theme.breakpoints.up('md')]: {
            backgroundColor: theme.palette.common.black
        },
    },
    '.PageLayout-root': {

    },
    
    '.PageLayout-content': {
        justifyContent: 'center',
        flexDirection: 'column !important',

        [theme.breakpoints.up('lg')]: {
            flexDirection: 'row !important',
        }
    },
    /*
    '.PageNavBar-root': {
        flexGrow: 1
    },
    '#root .MuiToolbar-root': {
        lineHeight: '1',
        minHeight: '60px',
        padding: `${theme.spacing(1)} ${theme.spacing(2)} 0 ${theme.spacing(2)}`,

        [theme.breakpoints.up('lg')]: {
            padding: `${theme.spacing(2.5)} ${theme.spacing(5)}`,
            minHeight: '104px'
        },
    },
    '#root .MuiToolbar-root .MuiBox-root:nth-of-type(1), #root .MuiToolbar-root .MuiBox-root:nth-of-type(3)': {
        flex: '1 1 0%'
    },
    '#root .MuiToolbar-root .MuiBox-root:nth-of-type(2)': {
        flex: '0 1 0%'
    },
    '#root .MuiToolbar-root .MuiBox-root:nth-of-type(3)': {
        textAlign: 'right',
    },
    '.PageNavBar-root .MuiAppBar-root .MBLogo': {
        height: '44px',
        width: '44px',

        [theme.breakpoints.up('lg')]: {
            height: '64px',
            width: '64px'
        },
    },
    '.PageNavBar-root .MuiAppBar-root .MBLegalTitle': {
        display: 'inline-block',
        fontFamily: 'MB Corpo A Title Condensed',
        fontSize: '1.25rem',
        marginLeft: '22px',
        lineHeight: '44px',
        verticalAlign: 'top',

        '& span': {
            color: theme.palette.primary.main
        },

        [theme.breakpoints.up('lg')]: {
            fontSize: '22px',
            marginLeft: '32px',
            lineHeight: '64px',
        },
    },*/
    '.PageContainer-root': {
        margin: '0 !important',
    },
    '.PageLayout-root .PageTitle': {
        fontSize: '1.5rem',
        lineHeight: '2rem',
        textAlign: 'center',
        margin: `${theme.spacing(2)}`,
        zIndex: 10,
        position: 'relative',

        [theme.breakpoints.up('sm')]: {
            fontSize: '2rem',
            lineHeight: '3rem',
            marginBottom: theme.spacing(6),
            backgroundColor: theme.palette.common.black,
            position: 'relative',
            zIndex: 200
        },

        [theme.breakpoints.up('md')]: {
            marginTop: `${theme.spacing(4)}`
        }
    },
    '.ContactForm-form': {
        minHeight: `calc(100vh - 190px)`,
    },
    'body.contact .ContactForm-root': {
        display: 'block',

        [theme.breakpoints.up('lg')]: {
            width: `calc(250px + ${theme.spacing(8)})`,
        },

        [theme.breakpoints.up(1440)]: {
            width: `calc((${theme.breakpoints.values.lg}px - ${theme.spacing(6)}) * 0.40)`,
        },
    },
    '.ContactForm-root': {
        padding: `${theme.spacing(2)}`,
        paddingTop: `${theme.spacing(4)}`,
        display: 'none',
        width: '100%',

        '& .MuiFormControlLabel-root .MuiRadio-root': {
            padding: '4px 9px',
        },

        [theme.breakpoints.up('sm')]: {
            paddingLeft: `${theme.spacing(3)}`,
            paddingRight: `${theme.spacing(3)}`,
        },

        [theme.breakpoints.up('lg')]: {
            transition: theme.transitions.create(['width'], {
                duration: theme.transitions.duration.standard,
                easing: theme.transitions.easing.easeInOut,
            }),
            paddingTop: 0,
            paddingLeft: 0,
            width: 0,
            overflow: 'hidden',

            '& > .ContactForm-wrapper': {
                width: `250px`,
                paddingLeft: `${theme.spacing(2)}`,
                paddingRight: `${theme.spacing(3)}`,

                [theme.breakpoints.up(1440)]: {
                    width: `calc((${theme.breakpoints.values.lg}px - ${theme.spacing(6)}) * 0.40)`,
                    paddingLeft: `${theme.spacing(2)}`,
                    paddingRight: `${theme.spacing(3)}`,
                },
            },
        }
    },
    '.ContactForm-headline': {
        marginBottom: `${theme.spacing(4)} !important`,
    },
    '.ConfigPage-bg': {
        position: 'relative',
        display: 'block',
        marginBottom: '-40px',
        marginTop: '-30px',
        top: 0,
        right: 0,
        width: '100%',
        zIndex: 1,

        '& img': {
            width: '100%',
            height: 'auto',
        },

        [theme.breakpoints.up('md')]: {
            display: 'block',
            position: 'absolute',
            bottom: `300px`,
            right: `calc((((100vw - ${theme.spacing(6)}) * 0.67) - ${theme.spacing(4)} - min(516px, ((100vw - ${theme.spacing(6)}) * 0.67 - ${theme.spacing(4)}))) * 0.5)`,
            top: 'auto',
            width: 'auto',
            marginBottom: 'auto',
            marginTop: 'auto',

            '& img': {
                width: `calc((100vw - ${theme.spacing(6)}) * 0.67 - ${theme.spacing(4)})`,
                maxWidth: '516px',
            },
        },

        [theme.breakpoints.up('lg')]: {
            right: `calc((((${theme.breakpoints.values.lg}px - ${theme.spacing(6)}) * 0.67) - ${theme.spacing(4)} - min(516px, ((${theme.breakpoints.values.lg}px - ${theme.spacing(6)}) * 0.67 - ${theme.spacing(4)}))) * 0.5)`,
            
            '& img': {
                width: `calc((${theme.breakpoints.values.lg}px - ${theme.spacing(6)}) * 0.67 - ${theme.spacing(4)})`,
            },
        }
    },
    'footer.MuiAppBar-root': {
        paddingTop: '20px',

        '.Footer-disclaimer, .Address': {
            display: 'none',
        },
    },
    '.MuiSlider-root .MuiSlider-valueLabel': {
        backgroundColor: theme.palette.background.default,
        color: theme.palette.primary.contrastText,
    },
    '.cta-print': {
        display: 'none',
    },
    '.AdditionalOptions-root': {
        '.MuiCheckbox-root': {
            paddingTop: `2px`,
            paddingBottom: `2px`,
        }
    },
    'body.print': {
        '& #button-print': {
            display: 'none',
        },
        '& .MuiSlider-thumb input': {
            visibility: 'hidden',
        },
        '& .MuiSlider-root .MuiSlider-valueLabel': {
            transition: 'none'
        },
        '& .cta-print': {
            display: 'block',
            lineHeight: '38px',
            fontFamily: 'MB Corpo S Title Condensed',
            fontSize: '1.25rem',
        },
        '& .ConfigArea-controls': {
            display: 'none',
        },
        '& .ConfigArea-controls-print': {
            display: 'block',
            marginBottom: '100px',
            [theme.breakpoints.up('lg')]: {
                marginBottom: '180px',
            }
        },
        /*'& .ConfigArea-options': {
            display: 'block',
        },*/
        '& footer.MuiAppBar-root': {
            '> .MuiStack-root': {
                '> .MuiStack-root:nth-of-type(1)': {
                    whiteSpace: 'nowrap',
                },
                '> .MuiStack-root:nth-of-type(2)': {
                    alignItems: 'flex-start',
                    //gap: '40px',

                    '> .MuiBox-root:nth-of-type(1)': {
                        flex: '1 1 70%'
                    },
                    '> .MuiBox-root:nth-of-type(2)': {
                        flex: '1 1 30%'
                    }
                },

                ':nth-of-type(2) > .MuiBox-root:nth-of-type(2)': {
                    display: 'none',
                }
            },
            '.Footer-disclaimer, .Address': {
                display: 'block',
            },
        },
        '& .ConfigPage-bg': {
            [theme.breakpoints.up('sm')]: {
                '@media (orientation: landscape)': {
                    bottom: `220px`,
                },
                bottom: `270px`,
            }
        }
    }
}

export default AppStyles